import {
  Document,
  Font,
  Image,
  Page,
  StyleSheet,
  Text,
  View
} from "@react-pdf/renderer";

import OpenSansItalic from "common/fonts/OpenSans-Italic.ttf";
import OpenSansMedium from "common/fonts/OpenSans-Medium.ttf";
import OpenSansRegular from "common/fonts/OpenSans-Regular.ttf";
import FontBold from "common/fonts/Roboto-Bold.ttf";
import RobotoFont from "common/fonts/Roboto-Regular.ttf";
import { getFormattedValue } from "common/utils";

Font.register({
  family: "Roboto",
  fonts: [{ src: RobotoFont }, { src: FontBold, fontWeight: "bold" }]
});

Font.register({
  family: "Open Sans",
  fonts: [
    { src: OpenSansRegular },
    { src: OpenSansMedium, fontWeight: "medium" },
    { src: OpenSansItalic, fontStyle: "italic" }
  ]
});

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontFamily: "Roboto",
    fontSize: 9
  },

  logo: {
    width: 200,
    height: 40,
    marginBottom: 10,
    justifyContent: "center"
  },
  tagline: {
    fontSize: 8,
    color: "#666666",
    marginTop: 2
  },
  titleSection: {
    width: "40%",
    alignItems: "center"
  },
  purchaseOrderTitle: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#000000"
  },
  poNumber: {
    fontSize: 10,
    marginTop: 5
  },
  dateSection: {
    width: "30%",
    alignItems: "flex-end"
  },
  dateText: {
    fontSize: 9
  },
  mainContainer: {
    // borderWidth: 1,
    // borderColor: "#000000",
    padding: 10
  },
  toSection: {
    marginBottom: 10
  },
  toLabel: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 3
  },
  companyName: {
    fontSize: 10,
    fontWeight: "bold"
  },
  address: {
    fontSize: 9,
    color: "#090101",
    width: "30%",
    whiteSpace: "initial"
  },
  companyAddress: {
    fontSize: 9,
    color: "#090101",
    width: "70%",
    whiteSpace: "initial"
  },
  poDetailsGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 10,
    marginBottom: 10,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000000",
    paddingVertical: 8
  },
  poDetailRow: {
    width: "33.33%",
    flexDirection: "row",
    marginBottom: 3
  },
  poDetailLabel: {
    fontSize: 9,
    width: 70,
    fontWeight: "bold"
  },
  poDetailValue: {
    fontSize: 9,
    flex: 1
  },
  attentionSection: {
    marginBottom: 10
  },
  attentionText: {
    fontSize: 9,
    marginBottom: 2
  },
  supplyText: {
    fontSize: 9,
    marginBottom: 10
  },
  table: {
    marginTop: 10,
    borderWidth: 1,
    borderBottomWidth: 0,
    borderColor: "#000000"
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f0f0f0",
    borderBottomWidth: 1,
    height: 15,
    borderBottomColor: "#000000"
    //  paddingVertical: 5
  },
  tableHeaderCell: {
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    paddingHorizontal: 5
  },
  snoCell: {
    width: "8%",
    textAlign: "center"
  },
  descCell: {
    width: "32%",
    textAlign: "left",
    paddingLeft: 5,
    borderRightWidth: 1,
    borderRightColor: "#000000"
  },
  qtyCell: {
    width: "12%",
    textAlign: "center"
  },
  unitCell: {
    width: "10%",
    textAlign: "center"
  },
  rateCell: {
    width: "15%",
    textAlign: "right",
    paddingRight: 5
  },
  amountCell: {
    width: "23%",
    textAlign: "right",
    borderRightWidth: 0,
    paddingRight: 5
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    minHeight: 40 // Add minimum height
  },
  tableCell: {
    fontSize: 9,
    // height: 40,
    paddingVertical: 8, // Add vertical padding

    borderRightWidth: 1,
    borderRightColor: "#000000",
    textAlign: "center",
    paddingHorizontal: 5
  },
  termsNote: {
    fontSize: 8,
    marginTop: 5,
    marginBottom: 10
  },
  amountInWords: {
    fontSize: 9,
    fontWeight: "bold",
    marginBottom: 15,
    //  borderBottomWidth: 1,
    borderBottomColor: "#000000",
    paddingBottom: 8
  },
  addressGstGrid: {
    flexDirection: "row",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000000",
    marginBottom: 10
  },
  leftAddressSection: {
    width: "50%",
    padding: 8,
    borderRightWidth: 1,
    borderRightColor: "#000000"
  },
  rightGstSection: {
    width: "50%",
    padding: 8
  },
  sectionTitle: {
    fontSize: 9,
    fontWeight: "bold",
    marginBottom: 3
  },
  addressText: {
    fontSize: 8,
    lineHeight: 1.3
  },
  gstText: {
    fontSize: 8,
    lineHeight: 1.3
  },
  contactSection: {
    marginBottom: 10,
    fontSize: 8
  },
  grandTotalRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    marginBottom: 15
  },
  grandTotalLabel: {
    fontSize: 9,
    fontWeight: "bold",
    marginRight: 10
  },
  grandTotalValue: {
    fontSize: 11,
    fontWeight: "bold",
    borderWidth: 1,
    borderColor: "#000000",
    paddingHorizontal: 15,
    paddingVertical: 3
  },
  termsSection: {
    marginTop: 10,
    paddingTop: 8
  },
  termsTitle: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 5
  },
  termItem: {
    fontSize: 8,
    marginBottom: 3,
    lineHeight: 1.3
  },
  signatureSection: {
    marginTop: 40,
    alignItems: "flex-end"
  },
  signatureText: {
    fontSize: 9,
    marginTop: 30,
    borderTopColor: "#000000",
    paddingTop: 5,
    width: 200,
    textAlign: "center"
  },
  header: {
    flexDirection: "row",
    marginBottom: 5
  },
  logoSection: {
    width: "auto",
    textAlign: "center",
    marginLeft: "30%"
  },
  title: {
    width: "70%"
  },
  companyTitle: {
    fontSize: 24,
    color: "#21206aff",
    fontWeight: 700,
    marginTop: 5,
    marginLeft: 30,
    textAlign: "center"
  },
  companyFullTitle: {
    color: "rgb(0, 0, 7)",
    fontSize: 12,
    fontFamily: "Open Sans",
    fontWeight: "bold"
  },
  companyInfo: {
    fontSize: 10,
    lineHeight: 1.4,
    color: "#7c7a7aff"
  },
  invoiceTitleSection: {
    alignItems: "center"
  },
  invoiceTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: "rgb(31, 31, 32)"
  },
  invoiceSection: {
    flexDirection: "row",
    justifyContent: "space-between"
  },
  poSection: {
    flexDirection: "row",
    marginTop: 10,
    marginLeft: 10,
    justifyContent: "space-between"
  },
  invoiceNumber: {
    fontSize: 13,
    marginTop: 5,
    color: "#7c7a7aff",
    fontWeight: "bold"
  },
  invoiceDate: {
    fontSize: 12,
    marginTop: 5
  },
  section: {
    marginBottom: 0
  },
  billTo: {
    fontSize: 12,
    fontFamily: "Open Sans",
    fontWeight: "600"
  },
  phoneNumber: {
    fontSize: 10
  },

  label: {
    fontWeight: "bold"
  },

  cell: {
    flex: 1,
    paddingHorizontal: 3
  },
  cellWide: {
    flex: 2,
    textAlign: "left",
    paddingHorizontal: 3
  },
  gst: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  gstValue: {
    marginRight: 5
  },
  totals: {
    fontSize: 10,
    marginTop: 15,
    marginLeft: 400,
    lineHeight: 1.5
  },
  gstName: {
    marginBottom: 6
  },
  totalLine: {
    marginTop: 3,
    paddingRight: 4
  },
  totalBold: {
    fontWeight: "bold",
    paddingLeft: 5,
    backgroundColor: "#a3f28d",
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    textAlign: "center",
    justifyContent: "space-between"
  },
  bankDetails: {
    fontSize: 11,
    marginTop: 20,
    lineHeight: 1.4
  },
  bankDetail: {
    fontSize: 9,
    fontWeight: "bold",
    textDecoration: "underline"
  },
  validity: {
    fontSize: 9,
    marginTop: 6,
    fontWeight: "bold"
  },

  inWords: {
    fontSize: 11,
    marginTop: -10,
    color: "#7c7a7aff",
    width: "60%",
    flexWrap: "wrap",
    textAlign: "left"
  },
  poDetails: {
    flexDirection: "row",
    alignItems: "flex-start"
  },
  poDetailsText: {
    fontSize: 10
  },
  poDetailsHeader: {
    fontSize: 10,
    width: 80,
    fontFamily: "Open Sans",
    fontWeight: "medium"
  },
  colon: {
    marginHorizontal: 5,
    fontSize: 12
  },
  poBody: {
    marginTop: 20,
    border: "1px solid #0f0f0f"
  },
  footerContainer: {
    marginTop: 20,
    flexDirection: "row"
  },
  footer: {
    fontSize: 9,
    border: "1px solid #0f0f0f",
    marginTop: 30
  },
  signature: {
    fontSize: 10,
    textAlign: "right",
    border: "1px solid #0f0f0f",

    marginTop: 40
  },
  billingContainer: {
    width: "38%",
    borderLeftWidth: 1,
    borderColor: "#000000"
  },
  billContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    paddingVertical: 5,
    paddingHorizontal: 6,
    width: "100%"
  },
  billText: {
    fontSize: 9
  },
  boldText: {
    fontWeight: "bold"
  },
  billValue: {
    fontSize: 9,
    textAlign: "right"
  },
  backGroundImage: {
    position: "absolute",
    top: "50%",
    opacity: 0.1,
    width: 300,
    height: 300,
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  totalsWrapper: {
    flexDirection: "row",
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000000"
  },

  amountWordsBox: {
    width: "62%",
    padding: 8,
    justifyContent: "flex-start"
  }
});

const DownloadPdf = ({ companyDetails }) => {
  const getGst = (price, gst) => ((gst / 100) * price).toFixed(2);

  const getTotal = companyDetails?.total
    ? Number(Math.round(getGst(companyDetails?.total, 18))) +
      Number(Math.round(companyDetails.total))
    : 0;

  const inWords = (number) => {
    const a = [
      "",
      "One ",
      "Two ",
      "Three ",
      "Four ",
      "Five ",
      "Six ",
      "Seven ",
      "Eight ",
      "Nine ",
      "Ten ",
      "Eleven ",
      "Twelve ",
      "Thirteen ",
      "Fourteen ",
      "Fifteen ",
      "Sixteen ",
      "Seventeen ",
      "Eighteen ",
      "Nineteen "
    ];
    const b = [
      "",
      "",
      "Twenty ",
      "Thirty ",
      "Forty ",
      "Fifty ",
      "Sixty ",
      "Seventy ",
      "Eighty ",
      "Ninety "
    ];

    const num = number
      .toString()
      .padStart(9, "0")
      .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);

    if (!num) return "";

    let str = "";

    const twoDigitWord = (val) => {
      const n = Number(val);
      if (n === 0) return "";
      if (n < 20) return a[n];
      return b[val[0]] + a[val[1]];
    };

    if (num[1] !== "00") str += `${twoDigitWord(num[1])} Crore`;

    if (num[2] !== "00") str += `${twoDigitWord(num[2])} Lakh `;

    if (num[3] !== "00") str += `${twoDigitWord(num[3])} Thousand `;

    if (num[4] !== "0") str += `${a[Number(num[4])]} Hundred `;

    if (num[5] !== "00") {
      str += `${str !== "" ? "And" : ""}  ${twoDigitWord(num[5])} Rupees Only`;
    }

    return str.trim();
  };

  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.header}>
          <View style={styles.logoSection}>
            {companyDetails?.companyDetails?.presignedUrl && (
              <Image
                src={companyDetails?.companyDetails?.presignedUrl}
                style={styles.logo}
              />
            )}{" "}
          </View>
        </View>
        <View style={styles.invoiceTitleSection}>
          <Text style={styles.invoiceTitle}>Purchase Order</Text>
        </View>

        <View style={styles.poSection}>
          <View style={styles.section}>
            <Text style={styles.billTo}>To :</Text>
            <Text style={styles.companyFullTitle}>
              {companyDetails?.vendorName}
            </Text>
            <Text style={styles.address}>{companyDetails?.address}</Text>
          </View>

          <View style={styles.section}>
            <View style={styles.poDetails}>
              <Text style={styles.poDetailsHeader}>P.O No. </Text>
              <Text style={styles.colon}> : </Text>
              <Text style={styles.poDetailsText}>
                {companyDetails?.poNumber}
              </Text>
            </View>
            <View style={styles.poDetails}>
              <Text style={styles.poDetailsHeader}>Ref No. </Text>
              <Text style={styles.colon}> : </Text>

              <Text style={styles.poDetailsText}>
                {companyDetails?.referenceNumber}
              </Text>
            </View>
            <View style={styles.poDetails}>
              <Text style={styles.poDetailsHeader}>Insurance </Text>
              <Text style={styles.colon}> : </Text>
              <Text style={styles.poDetailsText}>
                {companyDetails?.insurance}
              </Text>
            </View>
            <View style={styles.poDetails}>
              <Text style={styles.poDetailsHeader}>Freight </Text>
              <Text style={styles.colon}> : </Text>
              <Text style={styles.poDetailsText}>
                {companyDetails?.freight}
              </Text>
            </View>
            <View style={styles.poDetails}>
              <Text style={styles.poDetailsHeader}>shipment </Text>
              <Text style={styles.colon}> : </Text>
              <Text style={styles.poDetailsText}>
                {companyDetails?.shipment}
              </Text>
            </View>
            <View style={styles.poDetails}>
              <Text style={styles.poDetailsHeader}>Payment </Text>
              <Text style={styles.colon}> : </Text>
              <Text style={styles.poDetailsText}>
                {companyDetails?.payment}
              </Text>
            </View>
          </View>
        </View>

        <View style={styles.mainContainer}>
          <View style={styles.table}>
            <View style={styles.tableHeader}>
              <Text style={[styles.tableHeaderCell, styles.snoCell]}>
                S.No.
              </Text>
              <Text style={[styles.tableHeaderCell, styles.descCell]}>
                Description
              </Text>
              <Text style={[styles.tableHeaderCell, styles.qtyCell]}>Qty</Text>
              <Text style={[styles.tableHeaderCell, styles.unitCell]}>
                Unit
              </Text>
              <Text style={[styles.tableHeaderCell, styles.rateCell]}>
                Rate {companyDetails?.currency === "USD" ? "($)" : "(Rs.)"}
              </Text>
              <Text style={[styles.tableHeaderCell, styles.amountCell]}>
                Amount {companyDetails?.currency === "USD" ? "($)" : "(Rs.)"}
              </Text>
            </View>

            <View style={styles.tableRow}>
              <Text style={[styles.tableCell, styles.snoCell]}>1</Text>
              <View style={[styles.descCell, { padding: 0 }]}>
                <View
                  style={{
                    flexDirection: "column",
                    minHeight: 100,
                    paddingTop: 8,
                    paddingHorizontal: 5
                  }}
                >
                  <Text style={{ fontSize: 9, fontWeight: "medium" }}>
                    {companyDetails?.materialName}
                  </Text>
                  {companyDetails?.casNumber && (
                    <Text
                      style={{ fontSize: 8, color: "#000000", marginTop: 2 }}
                    >
                      CAS No. {companyDetails.casNumber}
                    </Text>
                  )}
                  {companyDetails?.note && (
                    <Text
                      style={{ fontSize: 8, color: "#000000", marginTop: 2 }}
                    >
                      Note: {companyDetails.note}
                    </Text>
                  )}
                </View>
              </View>
              <Text style={[styles.tableCell, styles.qtyCell]}>
                {companyDetails?.quantity}
              </Text>
              <Text style={[styles.tableCell, styles.unitCell]}>
                {companyDetails?.units}
              </Text>
              <Text style={[styles.tableCell, styles.rateCell]}>
                {companyDetails?.rate}
              </Text>
              <Text style={[styles.tableCell, styles.amountCell]}>
                {companyDetails?.quantity && companyDetails?.rate
                  ? getFormattedValue(
                      companyDetails.quantity * companyDetails.rate
                    )
                  : ""}
              </Text>
            </View>
          </View>
          <View style={styles.totalsWrapper}>
            <View style={styles.amountWordsBox}>
              <Text style={styles.amountInWords}>
                {` ${inWords(getTotal || 0)} Only`}
              </Text>
            </View>
            <View style={styles.billingContainer}>
              <View style={styles.billContainer}>
                <Text style={styles.billText}>Sub Total</Text>
                <Text style={styles.billValue}>
                  {getFormattedValue(companyDetails?.subTotal)}
                </Text>
              </View>
              <View style={styles.billContainer}>
                <Text style={styles.billText}>Discount</Text>
                <Text style={styles.billValue}>
                  {getFormattedValue(companyDetails?.discount)}
                </Text>
              </View>
              <View style={styles.billContainer}>
                <Text style={styles.billText}>Total</Text>
                <Text style={[styles.billValue, styles.boldText]}>
                  {getFormattedValue(companyDetails?.total)}
                </Text>
              </View>
              <View style={styles.billContainer}>
                <Text style={styles.billText}>GST @ 18%</Text>
                <Text style={styles.billValue}>
                  {getFormattedValue(getGst(companyDetails?.total, 18))}
                </Text>
              </View>
              <View style={styles.billContainer}>
                <Text style={styles.billText}>Insurance</Text>
                <Text style={styles.billValue}>-</Text>
              </View>
              <View style={styles.billContainer}>
                <Text style={styles.billText}>Freight</Text>
                <Text style={styles.billValue}>-</Text>
              </View>
              <View style={styles.billContainer}>
                <Text style={styles.billText}>Rounded off</Text>
                <Text style={styles.billValue}>-</Text>
              </View>
              <View style={[styles.billContainer, { borderBottomWidth: 0 }]}>
                <Text style={[styles.billText, styles.boldText]}>
                  Grand Total
                </Text>
                <Text style={[styles.billValue, styles.boldText]}>
                  {getFormattedValue(getTotal || 0)}
                </Text>
              </View>
            </View>
          </View>

          <View style={styles.addressGstGrid}>
            <View style={styles.leftAddressSection}>
              <Text style={styles.sectionTitle}>
                Invoice & Delivery Address :
              </Text>
              <Text style={[styles.addressText, styles.boldText]}>
                {companyDetails?.companyHead?.businessName}
              </Text>
              <Text style={styles.companyAddress}>
                {companyDetails?.address}
              </Text>
            </View>
            <View style={styles.rightGstSection}>
              <Text style={styles.sectionTitle}>Our GST Details :</Text>
              <Text style={styles.gstText}>
                GST No.: {companyDetails?.companyAddress?.gst}
              </Text>
              <Text style={styles.gstText}>
                DIVISION : {companyDetails?.companyAddress?.division}
              </Text>
              <Text style={styles.gstText}>
                COMMISSIONERATE :{" "}
                {companyDetails?.companyAddress?.commissionerate}
              </Text>
              <Text style={styles.gstText}>
                {companyDetails?.companyAddress?.rangeAddress}
              </Text>
            </View>
          </View>

          <View style={styles.termsSection}>
            <Text style={styles.termsTitle}>Terms & Conditions</Text>
            {companyDetails?.generalConditions?.map((term, index) => (
              <Text style={styles.termItem} key={term.id}>
                {index + 1}. {term?.conditions}
              </Text>
            ))}
          </View>
          {/* <Image src={GmfsLogo} style={styles.backGroundImage} /> */}

          <View style={styles.signatureSection}>
            <Text style={styles.signatureText}>Authorised Signatory</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default DownloadPdf;
